/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab.ts";

function getGetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabUrl(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/details-tab` as const,
  };
  return res;
}

/**
 * @description Retorna dados cadastrais, de curso, polo, status e documentação de uma matrícula para exibição na aba Detalhes do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna os detalhes de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/details-tab}
 */
export async function getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
